import data from "../../.sourceflow/partner_reasons.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const reasons_helper = new CollectionHelper(data);
